export default __webpack_public_path__ + "static/media/bullseye-smoky-white.903bc86d.svg";